import router from '@/router'

const jump = {
    business: (id, blank) => { // 跳商机
        if(blank){
            window.open(`/crm/business/detail/${id}`, '_blank')
        }else {
            router.push(`/crm/business/detail/${id}`);
        }
    },
    customer: (id, blank) => { // 跳客户
        if(blank){
            window.open(`/crm/customer/detail/${id}`, '_blank')
        }else {
            router.push(`/crm/customer/detail/${id}`);
        }
    },
    contract: (id, blank) => { // 跳合同
        if(blank){
            window.open(`/crm/contract/detail/${id}`, '_blank')
        }else {
            router.push(`/crm/contract/detail/${id}`);
        }
    },
    deliver: (id, blank) => { // 跳交付单
        if(blank){
            window.open(`/crm/deliveryOrder/detail/${id}`, '_blank')
        }else {
            router.push(`/crm/deliveryOrder/detail/${id}`);
        }
    },
    service: (id, blank) => { // 跳服务单
        if(blank){
            window.open(`/crm/serviceOrder/detail/${id}`, '_blank')
        }else {
            router.push(`/crm/serviceOrder/detail/${id}`);
        }
    }
}

export default jump
